export default {
  getDrainedWeight: (state) => state.drainedWeight,
};
